import { Share2 } from "lucide-react";
import { toast } from "sonner";

export function ShareButton({ compact = false, className = "" }) {
  const share = async () => {
    const url = window.location.origin;
    const data = { title: "Catch & Release", text: "Scan your catch, check the bite and climb the leaderboard.", url };
    if (navigator.share) {
      try { await navigator.share(data); } catch { /* cancelled */ }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — send it to your fishing crew");
    } catch {
      toast.error(`Copy this link: ${url}`);
    }
  };
  if (compact) {
    return (
      <button onClick={share} data-testid="share-app-btn-header" aria-label="Share the app"
        className="w-10 h-10 flex items-center justify-center border-2 border-[#F4F4F5] hover:bg-[#FF4D00] hover:text-black hover:border-black transition-colors">
        <Share2 size={18} />
      </button>
    );
  }
  return (
    <button onClick={share} data-testid="share-app-btn" className={`brut-btn ${className}`}>
      <Share2 size={18} /> Share the app
    </button>
  );
}
